import type { ISODate } from "../domain/model.js";

export type WaterSubscription = () => void;

export interface WaterRepository {
  getTotalMilliliters(date: ISODate): Promise<number>;
  addMilliliters(date: ISODate, milliliters: number): Promise<void>;
  setTotalMilliliters(date: ISODate, milliliters: number): Promise<void>;
  subscribe(date: ISODate, listener: () => void): WaterSubscription;
}

export function localISODate(date = new Date()): ISODate {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
